"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _paulCorePackage = require("paul-core-package");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const {
  hasimagesType,
  translationsKeyType
} = _paulCorePackage.customPropTypes;
const CardType = _propTypes.default.shape({
  coordinates: _propTypes.default.shape({
    latitude: _propTypes.default.number,
    longitude: _propTypes.default.number
  }),
  hasimages: hasimagesType,
  id: _propTypes.default.string.isRequired,
  thingCity: _propTypes.default.shape({
    [translationsKeyType]: _propTypes.default.string
  }),
  thingSiteAddress: _propTypes.default.shape({
    [translationsKeyType]: _propTypes.default.string
  }),
  thingZIPCode: _propTypes.default.shape({
    [translationsKeyType]: _propTypes.default.string
  })
});
exports.CardType = CardType;